module.exports = __webpack_public_path__ + "static/media/1201.e5059e78.jpg";